import gsap from "gsap";
import { ISDESKTOP } from "../constants/commonConstants";

class Dropdown {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.triggers = Array.from(this.DOM.el.querySelectorAll("[data-open-dropdown]"));
        this.DOM.backTriggers = Array.from(this.DOM.el.querySelectorAll("[data-dropdown-back]"));
        this.DOM.menu = this.DOM.el.querySelector(".nav--meta");
        this.DOM.dropdown = this.DOM.el.querySelector(".nav__dropdown");
        this.DOM.dropdownBg = this.DOM.el.querySelector(".dropdown__bg");
        this.minimalDropdownHeight = this.DOM.menu ? this.DOM.menu.getBoundingClientRect().height : 0;

        this.DOM.targets = [];
        this.DOM.triggers.forEach((trigger) =>
            this.DOM.targets.push(this.DOM.el.querySelector(trigger.dataset.openDropdown))
        );

        this.padding = 80;
        this.menuOpen = null;
        this.easing = { duration: 0.5, ease: "circ.inOut" };

        this.bgScale = {
			max: 1,
			min:
				(this.DOM.menu.getBoundingClientRect().width + this.padding) /
				this.DOM.dropdown.getBoundingClientRect().width,
		};

        this.initEvents();
    }
    initEvents = () => {
        this.DOM.triggers.forEach((trigger) =>
            trigger.addEventListener(ISDESKTOP ? "mouseenter" : "click", (event) => {
                if (trigger.hasAttribute("data-dropdown-desktop") && !ISDESKTOP) return;

                this.toggleDropdown(event, trigger);
            })
        );

        if (!ISDESKTOP && this.DOM.backTrigger !== null) {
            this.DOM.backTriggers.forEach((trigger) => trigger.addEventListener("click", () => this.removeClasses()));
        }

        if (ISDESKTOP) {
            gsap.set(this.DOM.dropdownBg, { scaleX: this.bgScale.min, transformOrigin: 'left' });
        }
    };
    toggleDropdown = (event, trigger) => {
        event.preventDefault();

        if (trigger) {
            if (trigger.classList.contains("is-active")) return;

            const target = this.DOM.el.querySelector(trigger.dataset.openDropdown);
            this.toggleClasses(trigger, target);
        }
    };

    toggleClasses = (trigger, target) => {
        this.DOM.triggers.forEach((trigger) => {
            trigger.classList.remove("is-active");
            trigger.setAttribute('aria-expanded', 'false');
        });
        this.DOM.targets.forEach((target) => {
			if (target) target.classList.remove('is-open');
		});

        if (trigger) {
			this.menuOpen = trigger;
			trigger.classList.toggle('is-active');
			trigger.setAttribute('aria-expanded', String(trigger.classList.contains('is-active')));
		}

        if (target) {
			target.classList.toggle('is-open');
		}
    };
    removeClasses = () => {
        this.menuOpen.classList.remove("is-active");
        this.menuOpen.setAttribute('aria-expanded', 'false');
        this.DOM.el.querySelector(this.menuOpen.dataset.openDropdown).classList.remove("is-open");
    };
}

const dropdownNodes = Array.from(document.querySelectorAll("[data-dropdown]"));
if (dropdownNodes !== null) {
    dropdownNodes.forEach((dropdown) => new Dropdown(dropdown));
}
